import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Careers.css';

const Careers = () => {
  return (
    <div className="careers-page">
      <Helmet>
        <title>Trabaja con Nosotros | Graphyra</title>
        <meta name="description" content="Únete al equipo de Graphyra y ayuda a construir el futuro del conocimiento" />
      </Helmet>

      <div className="careers-container">
        <section className="careers-hero">
          <h1 className="careers-title">Trabaja con Nosotros</h1>
          <p className="careers-subtitle">
            Ayúdanos a construir el futuro del conocimiento y la educación
          </p>
        </section>

        <section className="careers-content">
          <div className="content-card">
            <div className="icon-large">🚀</div>
            <h2>Estamos Creciendo</h2>
            <p className="lead-text">
              Graphyra está en sus primeras etapas de desarrollo, y estamos emocionados por el futuro 
              que nos espera. Aunque <strong>actualmente no tenemos posiciones abiertas</strong>, estamos 
              creciendo rápidamente.
            </p>
          </div>

          <div className="content-card">
            <div className="icon-large">💼</div>
            <h2>Próximamente</h2>
            <p>
              A medida que expandamos nuestra plataforma y comunidad, <strong>estaremos buscando talento 
              apasionado</strong> en diversas áreas:
            </p>
            <ul className="future-roles">
              <li>
                <strong>Desarrollo de Software:</strong> Frontend, Backend, Full-Stack, DevOps
              </li>
              <li>
                <strong>Diseño:</strong> UI/UX, Diseño Gráfico, Branding
              </li>
              <li>
                <strong>Contenido:</strong> Escritores, Editores, Creadores de Contenido Educativo
              </li>
              <li>
                <strong>Marketing:</strong> Community Management, Social Media, Growth
              </li>
              <li>
                <strong>Operaciones:</strong> Soporte al Usuario, Moderación de Contenido
              </li>
            </ul>
          </div>

          <div className="content-card highlight-card">
            <div className="icon-large">🌟</div>
            <h2>¿Qué Buscamos?</h2>
            <p>
              Cuando llegue el momento, buscaremos personas que compartan nuestra visión y valores:
            </p>
            <div className="qualities-grid">
              <div className="quality-item">
                <div className="quality-icon">❤️</div>
                <h3>Pasión por el Conocimiento</h3>
                <p>Crees en el poder de la educación y el acceso libre al conocimiento</p>
              </div>
              <div className="quality-item">
                <div className="quality-icon">💡</div>
                <h3>Innovación</h3>
                <p>Piensas fuera de la caja y aportas ideas creativas</p>
              </div>
              <div className="quality-item">
                <div className="quality-icon">🤝</div>
                <h3>Trabajo en Equipo</h3>
                <p>Colaboras, comunicas y contribuyes positivamente</p>
              </div>
              <div className="quality-item">
                <div className="quality-icon">🎯</div>
                <h3>Orientación a Resultados</h3>
                <p>Te comprometes con la excelencia y la mejora continua</p>
              </div>
            </div>
          </div>

          <div className="content-card">
            <div className="icon-large">📬</div>
            <h2>Mantente Informado</h2>
            <p>
              Si estás interesado en unirte a Graphyra en el futuro, <strong>mantente en contacto</strong>:
            </p>
            <div className="contact-options">
              <div className="contact-option">
                <h4>📧 Envía tu CV e Interés</h4>
                <p>
                  Aunque no tengamos posiciones abiertas ahora, nos encantaría conocerte. 
                  Envíanos tu CV y una carta explicando tu interés a:
                </p>
                <a href="mailto:contact.graphyra@gmail.com" className="contact-email">
                  contact.graphyra@gmail.com
                </a>
                <p className="note">Asunto: "Interés Laboral - [Tu Especialidad]"</p>
              </div>

              <div className="contact-option">
                <h4>🔔 Suscríbete</h4>
                <p>
                  Mantente al tanto de nuestro crecimiento y próximas oportunidades suscribiéndote 
                  a nuestro newsletter.
                </p>
                <Link to="/" className="subscribe-link">
                  Suscribirse al Newsletter
                </Link>
              </div>

              <div className="contact-option">
                <h4>🌐 Síguenos</h4>
                <p>
                  Sigue nuestras redes sociales para estar al día con novedades, actualizaciones 
                  y futuras convocatorias.
                </p>
              </div>
            </div>
          </div>

          <div className="content-card">
            <h2>¿Eres Estudiante o Freelancer?</h2>
            <p>
              Si bien no ofrecemos posiciones formales en este momento, <strong>siempre estamos abiertos 
              a colaboraciones</strong> con:
            </p>
            <ul className="collaboration-list">
              <li>
                <strong>Estudiantes universitarios</strong> que quieran contribuir con artículos, 
                investigación o proyectos académicos
              </li>
              <li>
                <strong>Creadores de contenido</strong> que deseen compartir su conocimiento y 
                expertise en sus áreas
              </li>
              <li>
                <strong>Desarrolladores freelance</strong> interesados en contribuir a proyectos 
                open-source o específicos
              </li>
            </ul>
            <p className="collaboration-note">
              Contáctanos en <a href="mailto:contact.graphyra@gmail.com">contact.graphyra@gmail.com</a> 
              {' '}para explorar posibilidades de colaboración.
            </p>
          </div>
        </section>

        <section className="careers-footer">
          <h3>Mientras Tanto...</h3>
          <p>
            Explora nuestra plataforma, únete a nuestra comunidad, y sé parte del crecimiento de Graphyra 
            como usuario, creador o colaborador.
          </p>
          <div className="footer-actions">
            <Link to="/about" className="footer-button">Conoce Más sobre Graphyra</Link>
            <Link to="/contact" className="footer-button secondary">Contáctanos</Link>
          </div>
        </section>

        <div className="page-footer">
          <div className="footer-links">
            <Link to="/about">Acerca de</Link>
            <span className="separator">•</span>
            <Link to="/contact">Contacto</Link>
            <span className="separator">•</span>
            <Link to="/">Volver al inicio</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
